import { useQuery, UseQueryOptions, UseQueryResult } from "react-query";
import { Queries } from "ui/query/queries";
import { giftcardsApi } from "../api/giftcardsApi";

export interface UseGetGiftCardCategoriesParams {
    query?: string;
}

export default function useGetGiftCardCategories(
    { query }: UseGetGiftCardCategoriesParams,
    options?: UseQueryOptions<string[], unknown, string[], (string | undefined)[]>,
): UseQueryResult<string[]> {
    return useQuery(
        [Queries.GET_GIFTCARD_CATEGORIES, query],
        async () => {
            const res = await giftcardsApi.getLocalGiftcardCategories({ query });
            return res.data;
        },
        { ...options },
    );
}
